var map = {
	"./Stroke 1.png": 2477,
	"./Why Our Save the Dat.png": 2478,
	"./all_about_shipping@2x.png": 2479,
	"./ask_for_everything@2x.png": 2480,
	"./big-day@1x.png": 2481,
	"./big-day@2x.png": 2482,
	"./birds@1x.png": 2483,
	"./birds@2x.png": 2484,
	"./check-list@1x.png": 2485,
	"./check-list@2x.png": 2486,
	"./circle-better@1x.png": 2487,
	"./circle-better@2x.png": 2488,
	"./empty_rsvp.png": 2489,
	"./empty_rsvp2x.png": 2490,
	"./envelope.png": 956,
	"./envelope.svg": 2491,
	"./envelope@2x.png": 2492,
	"./events_doodle.png": 834,
	"./events_doodle.svg": 2493,
	"./gifts@1x.png": 2494,
	"./gifts@2x.png": 2495,
	"./guest-list@1x.png": 2496,
	"./guest-list@2x.png": 2497,
	"./guest.png": 2498,
	"./guest.svg": 2499,
	"./guest2x.png": 2500,
	"./guest_approved@2x.png": 2501,
	"./invitations@1x.png": 2502,
	"./invitations@2x.png": 2503,
	"./invites_paper.svg": 2504,
	"./invites_paper@1x.png": 2505,
	"./invites_paper@2x.png": 2506,
	"./laptop-one-heart.png": 2507,
	"./laptop-one-heart@2x.png": 2508,
	"./laptop@1x.png": 2509,
	"./laptop@2x.png": 2510,
	"./long-page-checklist.png": 2511,
	"./long-page-checklist@2x.png": 2512,
	"./make_it_personal@2x.png": 2513,
	"./namecard-with-name.png": 2514,
	"./namecard-with-name@2x.png": 2515,
	"./namecard_no_name.svg": 835,
	"./namecard_with_name.svg": 2516,
	"./namecard_with_question_marks.svg": 460,
	"./no_address.png": 2517,
	"./no_address2x.png": 2518,
	"./onboarding_1.png": 2519,
	"./onboarding_1@2x.png": 2520,
	"./onboarding_2.png": 2521,
	"./onboarding_2@2x.png": 2522,
	"./onboarding_3.png": 2523,
	"./onboarding_3@2x.png": 2524,
	"./onboarding_4.png": 2525,
	"./onboarding_4@2x.png": 2526,
	"./red-star-left@1x.png": 2527,
	"./red-star-left@2x.png": 2528,
	"./red-star-right@1x.png": 2529,
	"./red-star-right@2x.png": 2530,
	"./registry_publish_champagne.svg": 2531,
	"./rsvp@1x.png": 2532,
	"./rsvp@2x.png": 2533,
	"./save-the-date@1x.png": 2534,
	"./save-the-date@2x.png": 2535,
	"./sparkle-left.svg": 871,
	"./sparkle-right.svg": 872,
	"./sparkle-up.svg": 877,
	"./ta-da.png": 2536,
	"./ta-da@2x.png": 2537,
	"./talk.svg": 2538,
	"./talk@1x.png": 909,
	"./talk@2x.png": 910,
	"./timeline-line-dark@1x.png": 2539,
	"./timeline-line-dark@2x.png": 2540,
	"./timeline-line@1x.png": 2541,
	"./timeline-line@2x.png": 2542,
	"./tips.svg": 731,
	"./underline_long@1x.png": 2543,
	"./underline_long@2x.png": 2544,
	"./underline_sm@1x.png": 2545,
	"./underline_sm@2x.png": 2546,
	"./website_publish_confetti.svg": 2547,
	"./wedding-websites@1x.png": 2548,
	"./wedding-websites@2x.png": 2549,
	"./wedding_help.png": 971,
	"./wedding_help.svg": 2550,
	"./wedding_help@2x.png": 2551
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 476
// module chunks = 68